import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../utils/loadable';

const addressQualComponent = Loadable(() => import('../../../components/Web/AddressQual/index'));
export default MapTo('vcg/components/soe-home/react/lq')(addressQualComponent);
